export class ConfigDB {
  static data = {
    settings: {
      layout_type: "ltr",
      layout: "Dubai",
      sidebar: {
        type: "compact-wrapper",
      },
      sidebar_setting: "default-sidebar",
    },
    color: {
      primary_color: "#4d8aff",
      secondary_color: "#fd2d63",
      mix_background_layout: "light-only",
    },
    router_animation: "fadeIn",
  };
}
export default ConfigDB;
